import PersonIcon from "@mui/icons-material/Person";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ArticleIcon from "@mui/icons-material/Article";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import DescriptionIcon from "@mui/icons-material/Description";
import SchoolIcon from "@mui/icons-material/School";
import FolderIcon from "@mui/icons-material/Folder";

export const BRAND_COLOR = "#4DABA4";
export const BRAND_COLOR_DARK = "#3d9993";
export const PROFILE_COLOR = "#7E57C2";

export const USAGE_TYPES = [
  { key: "usersWithProfile", refsKey: null, label: "Usuarios (perfil)", Icon: PersonIcon },
  { key: "userInterests", refsKey: null, label: "Usuarios (interés)", Icon: FavoriteIcon },
  { key: "courses", refsKey: "courseRefs", label: "Cursos", Icon: SchoolIcon },
  { key: "posts", refsKey: "postRefs", label: "Publicaciones", Icon: ArticleIcon },
  { key: "videos", refsKey: "videoRefs", label: "Videos", Icon: PlayCircleIcon },
  { key: "documents", refsKey: "documentRefs", label: "Documentos", Icon: DescriptionIcon },
  { key: "groups", refsKey: "groupRefs", label: "Grupos", Icon: FolderIcon },
];

export const getUsageTotal = (usage) =>
  usage ? USAGE_TYPES.reduce((sum, { key }) => sum + (usage[key] || 0), 0) : 0;

export const getErrorMessage = (error, fallback) => {
  const data = error?.response?.data;
  if (typeof data === "string" && data.trim()) return data;
  if (data?.message) return data.message;
  if (data?.title) return data.title;
  return fallback;
};

export const normalizeText = (value) =>
  (value || "")
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
